<div id="forgot-password" fxLayout="column">
    <div id="forgot-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="forgot-password-form" [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
            }">
            <div class="title">{{'AUTH_PAGE.RECOVER_PASSWORD' | translate}}</div>

            <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" novalidate>
                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" />
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="
                            forgotPasswordForm.get('email').hasError('required')
                        ">
                        {{'AUTH_PAGE.PLEASE_ENTER_EMAIL' | translate}}
                    </mat-error>
                    <mat-error *ngIf="
                            forgotPasswordForm.get('email').hasError('email')
                        ">
                        {{ 'AUTH_PAGE.INVALID_EMAIL' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-error *ngIf="sentFail">
                    {{ 'AUTH_PAGE.' + failMessageCode  | translate }}
                </mat-error>

                <button mat-raised-button class="submit-button" color="accent" (click)="sendForgotPasswordEmail()"
                    aria-label="SEND RESET LINK" [disabled]="forgotPasswordForm.invalid">
                    {{ 'AUTH_PAGE.SEND_CONFIRMATION_CODE' | translate }}
                </button>
            </form>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'/auth/login'">{{
                    'AUTH_PAGE.BACK' | translate
                    }}</a>
            </div>
        </div>
    </div>
</div>